export enum EmiStatus {
    Scheduled = 'scheduled',
    NachInitiated = 'emi_nach_initiated',
    NachFailed = 'emi_nach_failed',
    Received = 'emi_received',
    Completed = 'emi_completed',
    Paid = 'paid',
    PDCInitiated = 'pdc_initiated',
    PDCFailed = 'pdc_failed'
}
